import { z } from "zod";

// Recorded when a data subject is erased (GDPR). Kept for audit; the actual
// erasure is destroying the subject's encryption key (crypto-shredding).
export const dataSubjectErased = z.object({
  type: z.literal("DataSubjectErased"),
  userId: z.string().min(1),
  reason: z.string().optional(),
});

export const dataSubjectEvents = [dataSubjectErased] as const;
